export default __webpack_public_path__ + "static/thumb-landscape-b51883d76703f46a9e30403557a3375e.jpg";